import { Container } from "react-bootstrap";
import { getAllUsers_Admin } from "../../../commons/Api";
import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import LaSpinner from "../../../components/spinner/LaSpinner.component";
import { handleErrorRouting } from "../../../commons/LaUtils";
import { useNavigate } from "react-router";
import Response_UserProfile from "../../../types/responses/Response.UserProfile.type";
import UserCard from "../../../components/userCard/UserCard.component";

const AllUsers = () => {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState<Response_UserProfile[]>();

  const navigate = useNavigate();

  useEffect(() => {
    getAllUsers_Admin()
      .then((response) => {
        setUsers(response.data);
      })
      .catch((error) => {
        handleErrorRouting(error, (url: string) => navigate(url));
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return loading ? (
    <Box sx={{ width: "100%", textAlign: "center" }}>
      <LaSpinner />
    </Box>
  ) : (
    <Container>
      <div>
        {users?.length + " users in a createdOn-descending order"}
      </div>
      <div>
        {users !== undefined &&
          users.map((user: Response_UserProfile) => {
            return (
              <UserCard
                key={user.id}
                userId={user.id}
                email={user.email}
                displayName={user.displayName}
                firstName={user.firstName}
                lastName={user.lastName}
                about={user.about}
                activated={user.activated}
                role={user.role}
                createdOn={user.createdOn}
                lastUpdatedOn={user.lastUpdatedOn}
                version={user.version}
              />
            );
          })}
      </div>
    </Container>
  );
};
export default AllUsers;
